export const Svg_105 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M9.625 61.25c-1.167 0-2.188-.438-3.063-1.313-.875-.874-1.312-1.895-1.312-3.062v-43.75c0-1.167.438-2.188 1.313-3.063.875-.874 1.895-1.312 3.062-1.312h50.75c1.167 0 2.188.438 3.063 1.313.874.874 1.312 1.895 1.312 3.062v43.75c0 1.167-.438 2.188-1.313 3.063-.874.874-1.895 1.312-3.062 1.312H9.625Zm0-4.375h50.75v-43.75H9.625v43.75Zm4.958-7.292h14.584V43.75H14.583v5.833Zm27.854-5.833 14.438-14.438-4.156-4.156L42.437 35.51l-4.156-4.156-4.083 4.156 8.24 8.24Zm-27.854-5.833h14.584v-5.834H14.583v5.834Zm0-11.667h14.584v-5.833H14.583v5.833Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.009}
        x2={42.447}
        y1={16.625}
        y2={59.615}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)